<template>
    <div class="Leaderboard">
        <div>Leaderboard</div>
        <br />
        <div>
            <div v-for="entry of leaderboard.entries" :key="entry.userId" class="Entry">
                {{ entry.userId }} - <b>{{ entry.score }}</b>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        leaderboard: {
            type: Object,
            required: true
        }
    }
};
</script>

<style scoped lang="scss">
.Leaderboard {
    padding: 1em;
    border: 1px solid rgba(black, 0.1);
    border-radius: 0.5em;
}
</style>
